/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/710/interface/api
 */
import { message } from 'ant-design-vue'
import { ref } from 'vue'
import {
  v1_station_letter_index_post,
  v1_station_letter_create_post,
  v1_station_letter_audit_post,
  v1_station_letter_unAudit_post
} from 'server/modules/4231' // 查询所有发表的站内信

export const v1_station_letter_index_post_ = function() {
  const messageList = ref([])

  const getMessages = async () => {
    const { success, data, retInfo } = await v1_station_letter_index_post()

    if (success) {
      messageList.value = data.list.slice(0, 5) // Object.assign(messageList, data.list)
    }
  }

  getMessages()
  return {
    messageList
  }
} // 创建站内信

export const v1_station_letter_create_post_ = function() {
  const vuex = JSON.parse(localStorage.getItem('vuex'))
  const userName = vuex.user.userInfo.userName
  const avatar = vuex.user.userInfo.avatar
  const formRef = ref(null)
  const rules = {
    message: [
      {
        required: true,
        message: '请输入内容'
      }
    ]
  }

  const trackLetter = async (params, callback) => {
    const result = await v1_station_letter_create_post({
      userName,
      avater: avatar,
      ...params
    })
    callback && callback(result)
  }
  const toSubmit = params => {
    trackLetter(params, res => {
      if (res.success) {
        if (params.type === 3) {
          message.success('已收到您的反馈！！！')
        } else {
          message.success('已收到您的反馈，等待管理员处理！！！')
        }
      } else {
        message.success('服务器异常，请重新操作')
      }
    })
  }
  // 发表意见
  const submitAdvice = (params, isValid) => {
    if (isValid) {
      formRef.value.validate().then(() => {
        toSubmit(params)
      })
    } else {
      toSubmit(params)
    }
  }

  return {
    submitAdvice,
    trackLetter,
    rules,
    formRef
  }
}

// 审核消息
export const v1_station_letter_audit_post_ = function(callback) {
  const toAudit = async params => {
    const { success, data, retInfo } = await v1_station_letter_audit_post({
      id: params.id,
      status: 1
    })
    if (success) {
      callback()
      message.success('审核通过')
    } else {
      console.log(data)
      message.error(retInfo)
    }
  }
  return {
    toAudit
  }
}

// 查询所有未审核列表
export const v1_station_letter_unAudit_post_ = function() {
  const unAuditList = ref([])
  const getUnAudit = async params => {
    const { success, data, retInfo } = await v1_station_letter_unAudit_post(
      params
    )
    if (success) {
      console.log(data)
      unAuditList.value = data.list
    } else {
      console.log(data)
      message.error(retInfo)
    }
  }
  getUnAudit()

  return {
    unAuditList,
    getUnAudit
  }
}
